/*
 * @Author: your name
 * @Date: 2021-06-07 09:35:32
 * @LastEditTime: 2021-07-30 20:05:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\router\modules\order.js
 */
/**
 * 订单路由
 */
export default [
  {
    path: '/orderList',
    component: resolve => require(['../../views/order/orderList'], resolve),
    meta: { title: '订单列表' }
  },{
    path: '/addOrder',
    component: resolve => require(['../../views/order/addOrder'], resolve),
    meta: { title: '新增散客订单' }
  },
  {
    path: '/addErpOrder',
    component: resolve => require(['../../views/order/addErpOrder'], resolve),
    meta: { title: '新增散客订单' }
  },
  {
    path: '/orderDetails',
    component: resolve => require(['../../views/order/orderDetails'], resolve),
    meta: { title: '订单详情' }
  },
  {
    path: '/order/orderProductDetail',
    component: resolve => require(['../../views/order/orderProductDetail'], resolve),
    meta: { title: '产品详情' }
  },
 
  {
    path: '/confirmOrder',
    component: resolve => require(['../../views/order/confirmOrder'], resolve),
    meta: { title: '确认订单' }
  },
  {
    path: '/order/handleChange',
    component: resolve => require(['../../views/order/handleChange'], resolve),
    meta: { title: '处理变更' }
  },
  {
    path: '/order/travelService',
    component: resolve => require(['../../views/order/travelService'], resolve),
    meta: { title: '常用旅客' }
  },
  {
    path: '/order/editTheOrder',
    component: resolve => require(['../../views/order/editTheOrder'], resolve),
    meta: { title: '我的订单' }
  },
  {
    path: '/order/teamEditTheOrder',
    component: resolve => require(['../../views/order/teamEditTheOrder'], resolve),
    meta: { title: '我的团队订单' }
  },
  {
    path: '/order/leavingGroup',
    component: resolve => require(['../../views/order/leavingGroup'], resolve),
    meta: { title: '出团通知书' }
  },
  {
    path: '/order/leavingSdes',
    component: resolve => require(['../../views/order/leavingSdes'], resolve),
    meta: { title: '出团通知书' }
  },
  {
    path: '/order/orderApplyChange',
    component: resolve => require(['../../views/order/orderApplyChange'], resolve),
    meta: { title: '变更申请' }
  },
  {
    path: '/order/orderApplyChangeErp',
    component: resolve => require(['../../views/order/orderApplyChangeErp'], resolve),
    meta: { title: '变更申请' }
  },
  {
    path: '/order/teamOrderApplyChange',
    component: resolve => require(['../../views/order/teamOrderApplyChange'], resolve),
    meta: { title: '团队订单变更申请' }
  },
  {
    path: '/order/teamOrderList',
    component: resolve => require(['../../views/order/teamOrderList'], resolve),
    meta: { title: '团队订单列表' }
  },
  {
    path: '/order/teamAddOrder',
    component: resolve => require(['../../views/order/teamAddOrder'], resolve),
    meta: { title: '创建团队订单' }
  },
  {
    path: '/order/teamOrderDetails',
    component: resolve => require(['../../views/order/teamOrderDetails'], resolve),
    meta: { title: '订单详情' }
  },
  {
    path: '/order/confirmTeamOrder',
    component: resolve => require(['../../views/order/confirmTeamOrder'], resolve),
    meta: { title: '确认订单' }
  },
  {
    path: '/pageDesign/index',
    component: resolve => require(['../../views/pageDesign/index'], resolve),
    meta: {title:'设计海报'}
  },
  {
    path: '/order/InitiateActionsPage',
    component: resolve => require(['../../views/order/InitiateActionsPage'], resolve),
    meta: { title: '发起决算' }
  },
  {
    path: '/order/confirmOrderList',
    component: resolve => require(['../../views/order/confirmOrderList'], resolve),
    meta: { title: '确认单列表' }
  },
  {
    path: '/order/confirmOrderBatch',
    component: resolve => require(['../../../owncomponents/order/order-confirm-batch'], resolve),
    meta: { title: '批量确认单列表' }
  },
  {
    path: '/order/confirmOrderDetail',
    component: resolve => require(['../../../owncomponents/order/order-confirm-view'], resolve),
    meta: { title: '确认单详情' }
  },

  

  
]



// WEBPACK FOOTER //
// ./src/SRM/router/modules/order.js